import * as React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppButton } from "../Generic/AppButton";
import PinCodeScreen from "../PinCodeScreen";

export interface PinUnlockScreenProps {
  pinValue: string;
  onChangePin: (pin: string) => void;
  onClickForgotPin: () => void;
}

const PinUnlockScreen = (props: PinUnlockScreenProps) => {
  const footer = (
    <AppButton variant="link" onClick={props.onClickForgotPin} style={{ marginTop: 16 }}>
      {translate(STRINGS.I_FORGOT_MY_PIN_CODE)}
    </AppButton>
  );

  return (
    <PinCodeScreen
      pinValue={props.pinValue}
      headline={translate(STRINGS.PLEASE_ENTER_YOUR_PIN_CODE)}
      footer={footer}
      onChangePin={props.onChangePin}
    />
  );
};

export default React.memo(PinUnlockScreen);
